import { Layout, Page } from "@fdoh/health-ui-react";
import TankInstallationForm from "../Components/TankInstallationForm";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { useHistory, useLocation } from "react-router-dom";

// TODO: Add error handling

const CreateTankInstallationPage = () => {
    const { search } = useLocation();
    const { state }: any = useLocation();
    const lastInspectionStatusData = state?.lastInspectionStatusData;     
    const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    
    // Pre-populate the specified fields from lastInspectionStatusData
    const prePopulatedData = lastInspectionStatusData ? {
        ...lastInspectionStatusData,
        tankSize1: lastInspectionStatusData.tankSize1,
        tankSize2: lastInspectionStatusData.tankSize2,
        tankMaterialId1: lastInspectionStatusData.tankMaterialId1,
        tankMaterialId2: lastInspectionStatusData.tankMaterialId2,
        multiChambered: lastInspectionStatusData.isMultiChambered === "1" ? true : false,
        outletFilterId: lastInspectionStatusData.outletFilterId,
        legendId1: lastInspectionStatusData.legendId1,
        legendId2: lastInspectionStatusData.legendId2
    } : null;

    return applicationId ? (
        <Page.Container>
            <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>          
            <Page.Body>
                <Layout.Container>
                    <TankInstallationForm
                        id="CreateTankInstallationForm"
                        title="Tank Installation Inspection"
                        action="post"
                        applicationId={applicationId ? applicationId : 0}
                        applicationInspectionId={inspectionId ? inspectionId : 0}
                        returnPath={`/inspectionDetails/${inspectionId}`}
                        values={prePopulatedData}
                    />
                </Layout.Container>
            </Page.Body>
        </Page.Container>
    ): <div></div>;
};

export default CreateTankInstallationPage;